/**
 * Индикатор статуса данных опционов (Real-time / Delayed)
 * ЗАЧЕМ: Показывает пользователю статус подключения к real-time данным опционов
 * Затрагивает: TopNav, отображение статуса Massive API
 */

import React from 'react';
import './LiveDataIndicator.css';
import massiveLogo from '../db.png';
import useMarketStatus from '../hooks/useMarketStatus';

const OptionsDataIndicator = () => {
  const { status, loading } = useMarketStatus();

  // Состояние загрузки
  if (loading) {
    return (
      <div className="live-indicator loading">
        <div className="indicator-logo-wrapper">
          <img src={massiveLogo} alt="Massive" className="indicator-logo" />
        </div>
        <span className="indicator-text">Проверка...</span>
      </div>
    );
  }

  // Если нет данных, не показываем индикатор
  if (!status) {
    return null;
  }

  // Определение CSS класса на основе статуса
  const getIndicatorClass = () => {
    const mode = status.market_mode;
    
    // Live торги - опционы торгуются
    if (mode === 'live') {
      return 'live';
    }
    // Pre-market, After-hours - возможны ограничения
    else if (mode === 'pre_open' || mode === 'after_hours') {
      return 'delayed';
    }
    // Перерыв в торгах
    else if (mode === 'break') {
      return 'delayed';
    }
    // Рынок закрыт
    else if (mode === 'historical' || mode === 'holiday') {
      return 'offline';
    }
    // По умолчанию offline
    else {
      return 'offline';
    }
  };

  // Текст индикатора
  const getIndicatorText = () => {
    const mode = status.market_mode;
    
    if (mode === 'live') {
      return 'Опционы: LIVE';
    } else if (mode === 'pre_open') {
      return 'Опционы: Pre-market';
    } else if (mode === 'after_hours') {
      return 'Опционы: After-hours';
    } else if (mode === 'break') {
      return 'Опционы: Break';
    } else if (mode === 'historical') {
      return 'Опционы: Closed';
    } else if (mode === 'holiday') {
      return 'Опционы: Holiday';
    } else {
      return 'Опционы: Offline';
    }
  };

  // Текст тултипа при наведении
  const getTooltipText = () => {
    const mode = status.market_mode;
    
    if (mode === 'live') {
      return 'Live торги опционами на фьючерсы';
    } else if (mode === 'pre_open') {
      return 'Pre-market - опционы могут быть недоступны';
    } else if (mode === 'after_hours') {
      return 'After-hours - опционы могут быть недоступны';
    } else if (mode === 'break') {
      return 'Перерыв в торгах опционами';
    } else if (mode === 'historical') {
      return 'Рынок закрыт (исторические данные)';
    } else if (mode === 'holiday') {
      return 'Праздник — торги опционами закрыты';
    } else {
      return 'Статус опционов неизвестен';
    }
  };

  return (
    <div 
      className={`live-indicator ${getIndicatorClass()}`}
      title={getTooltipText()}
    >
      <div className="indicator-logo-wrapper">
        <img 
          src={massiveLogo} 
          alt="Massive" 
          className="indicator-logo"
        />
      </div>
      <span className="indicator-text">{getIndicatorText()}</span>
    </div>
  );
};

export default OptionsDataIndicator;
